if (!customElements.get('email-popup')) {
  customElements.define('email-popup', class extends HTMLElement {
    static shown = false;
    connectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      cancelAnimationFrame(this.feedbackFrame);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      // Without this enhancement the same native form remains visible inline.
      if (!this.hasAttribute('data-popup-ready')) this.dialog.removeAttribute('open');
      this.setAttribute('data-popup-ready', '');
      this.storageKey = 'midibites:newsletter:dismissed-until';
      this.designMode = this.hasAttribute('data-design-mode');
      this.querySelector('[data-popup-close]').addEventListener('click', () => this.dialog.close(), options);
      // Native cancel behaviour handles Escape; the close event persists every dismissal.
      this.dialog.addEventListener('close', () => this.rememberDismissal(), options);
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      }, options);
      if (this.designMode) {
        document.addEventListener('shopify:section:select', event => {
          if (event.detail.sectionId === this.dataset.sectionId) this.open();
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.detail.sectionId === this.dataset.sectionId) this.dialog.close();
        }, options);
        return;
      }
      // Always reveal this native form's response, even after a prior dismissal.
      const response = this.querySelector('[data-popup-success], [data-popup-feedback]');
      let responseAnchor = '';
      try { responseAnchor = decodeURIComponent(location.hash.slice(1)); } catch { /* Ignore malformed fragments. */ }
      if (response && responseAnchor && responseAnchor !== this.querySelector('form')?.id) return;
      if (response) {
        this.open();
        this.feedbackFrame = requestAnimationFrame(() => {
          if (this.isConnected && this.dialog.open) this.querySelector('[data-popup-success], [data-popup-feedback] [role="alert"]')?.focus();
        });
        return;
      }
      if (this.constructor.shown || this.hasAttribute('data-subscribed') || new URLSearchParams(location.search).has('customer_posted') || this.isDismissed()) return;
      this.timer = setTimeout(() => this.open(), Math.max(0, Number(this.dataset.delay) || 3) * 1000);
    }
    isDismissed() {
      try {
        return Number(localStorage.getItem(this.storageKey)) > Date.now();
      } catch {
        // Respect unavailable storage: avoid repeatedly interrupting the visitor on each page.
        return true;
      }
    }
    rememberDismissal() {
      if (this.designMode) return;
      const days = Math.max(1, Number(this.dataset.dismissDays) || 30);
      try { localStorage.setItem(this.storageKey, String(Date.now() + days * 86400000)); } catch { /* Storage can be unavailable. */ }
    }
    open() {
      if (!this.isConnected || this.dialog.open || document.querySelector('dialog[open]')) return;
      this.dialog.showModal();
      if (!this.designMode) {
        this.constructor.shown = true;
        this.rememberDismissal();
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      cancelAnimationFrame(this.feedbackFrame);
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
